import React from 'react';
import { Row, Col, Form } from 'react-bootstrap';
import CourseCheckList from '../course-checklist';
import FormActions from '../form-actions';
import AssignmentSummaryPanel from '../assignment-summary-panel';
import { Course, SelectedAssignment } from '../../types';

const HANDOUT_URL = 'https://static1.squarespace.com/static/5892601aff7c50aa7531c614/t/64f24ace1a04fc00b48c0397/1693600463151/persistence+grading+with+bonus+handout.pdf';

interface PersistenceWithBonusPageProps {
  currentPage: number;
  courses: Course[];
  bonusCourseIds: number[];
  onToggle: (course: Course) => void;
  onBack: () => void;
  onSave: () => void;
  assignments: SelectedAssignment[];
  loading: boolean;
}

const PersistenceWithBonusPage = ({
  currentPage, courses, bonusCourseIds, onToggle, onBack, onSave, assignments, loading,
}: PersistenceWithBonusPageProps) => (
  <Row className="mt-5 mb-5">
    <Col sm={12} lg={6}>
      <b>{`${currentPage}. Select the course(s) you would like Persistence with Bonus to apply to`}</b>
      <p className="assignments-font-size mt-2">
        Persistence with Bonus grading allows students to earn back stars lost on required
        assignments by successfully completing additional assignments in the lesson without
        using help.
        {' '}
        [<a target="_blank" href={HANDOUT_URL} rel="noopener noreferrer" className="link">Learn more</a>]
      </p>
      <Form className="mt-2">
        <CourseCheckList
          courses={courses}
          isChecked={(course) => bonusCourseIds.includes(course.id)}
          onToggle={onToggle}
          emptyMessage="No active courses were selected on the previous step."
        />
        <FormActions onBack={onBack} onSave={onSave} />
      </Form>
    </Col>
    <Col sm={12} lg={6}>
      <AssignmentSummaryPanel assignments={assignments} loading={loading} />
    </Col>
  </Row>
);

export default PersistenceWithBonusPage;
